import { Box, Grid, Slider, TextField } from '@mui/material';
import { transformToScaledValue } from '@siren-frontend/shared';
import PropTypes from 'prop-types';

function insertValueSeparator(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function stripValueSeparator(value) {
  return Number(value.toString().replaceAll(',', ''));
}

function SpecSlider({ spec, onChange }) {
  const [specId, specValues] = spec;

  const isScaled = Boolean(specValues.scale);
  const inputValue = specValues.value || specValues.default;

  function handleTextFieldChange(ev) {
    const numberValue = stripValueSeparator(ev.target.value);

    if (
      numberValue > specValues.max ||
      numberValue < specValues.min ||
      isNaN(numberValue)
    ) {
      return;
    }

    onChange(specId, numberValue);
  }

  return (
    <Grid item className="input-group">
      <Grid container className="input-value-group">
        <Box>{specValues.name}</Box>
        <TextField
          className="input-textfield"
          value={insertValueSeparator(inputValue)}
          min={isScaled ? Math.log10(specValues.min) : specValues.min}
          max={isScaled ? Math.log10(specValues.max) : specValues.max}
          type="text"
          variant="outlined"
          onChange={handleTextFieldChange}
          id={`calc-slider-${specValues.testId}`}
          data-testid={`calc-slider-${specValues.testId}`}
        />
      </Grid>
      <Box>
        <Slider
          min={isScaled ? Math.log10(specValues.min) : specValues.min}
          max={isScaled ? Math.log10(specValues.max) : specValues.max}
          name={specValues.name}
          step={isScaled ? 0.02 : 1}
          value={isScaled ? Math.log10(inputValue) : inputValue}
          onChange={ev => {
            const newVal = isScaled
              ? transformToScaledValue(ev.target.value)
              : ev.target.value;
            onChange(specId, newVal);
          }}
          scale={specValues.scale}
          id={`calc-slider-${specValues.testId}`}
          data-testid={`calc-slider-${specValues.testId}`}
        />
        <Box className="input-marks">
          <span>{specValues.marks[0]}</span>
          <span>{specValues.marks[1]}</span>
        </Box>
      </Box>
    </Grid>
  );
}

SpecSlider.propTypes = {
  spec: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SpecSlider;
